
import React from 'react';
import { Mail, Phone, MessageCircle, Globe, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navbar } from '@/components/Navbar';
import AuthNavigation from '@/components/navigation/AuthNavigation';

const ContactUs = () => {
  const handleEmailClick = () => {
    window.location.href = 'mailto:lynnscott@bluetoothcash.net';
  };

  const handlePhoneClick = () => {
    window.location.href = 'tel:7205374766';
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-white shadow-sm p-6 flex justify-between items-center">
        <div className="flex items-center space-x-4">
          <Link to="/">
            <Button variant="ghost" size="icon" className="rounded-full">
              <ArrowLeft className="h-5 w-5" />
            </Button>
          </Link>
          <h1 className="text-2xl font-bold text-gray-900">Contact Us</h1>
        </div>
        <AuthNavigation />
      </header>
      
      <main className="flex-grow container mx-auto px-6 py-10 space-y-8">
        <div className="bg-white rounded-xl shadow-md p-6 space-y-4">
          <div className="flex items-center space-x-4">
            <Mail className="text-blue-600 h-6 w-6" />
            <div>
              <h2 className="font-semibold text-gray-800">Email</h2>
              <p className="text-gray-600">lynnscott@bluetoothcash.net</p>
            </div>
          </div>
          
          <Button 
            onClick={handleEmailClick}
            className="w-full bg-blue-500 hover:bg-blue-600"
          >
            Send Email
          </Button>
        </div>

        <div className="bg-white rounded-xl shadow-md p-6 space-y-4">
          <div className="flex items-center space-x-4">
            <Phone className="text-green-600 h-6 w-6" />
            <div>
              <h2 className="font-semibold text-gray-800">Phone</h2>
              <p className="text-gray-600">720 537 4766</p>
            </div>
          </div>
          
          <Button 
            onClick={handlePhoneClick}
            className="w-full bg-green-500 hover:bg-green-600"
          >
            Call Now
          </Button>
        </div>
        
        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-white rounded-xl shadow-md p-6 space-y-4">
            <div className="flex items-center space-x-4">
              <MessageCircle className="text-green-600 h-6 w-6" />
              <h2 className="font-semibold text-gray-800">Send a Message</h2>
            </div>
            <p className="text-gray-600">
              We're here to help! Reach out to us with any questions or concerns.
            </p>
          </div>
          
          <div className="bg-white rounded-xl shadow-md p-6 space-y-4">
            <div className="flex items-center space-x-4">
              <Globe className="text-purple-600 h-6 w-6" />
              <h2 className="font-semibold text-gray-800">Our Website</h2>
            </div>
            <p className="text-gray-600">
              Learn more about our services at bluetoothcash.net
            </p>
          </div>
        </div>
      </main>
      
      <Navbar />
    </div>
  );
};

export default ContactUs;
